module.exports = (__parcel__import__("lya96")).then(() => parcelRequire('4MKVl'));